
// Shorter timeout for mobile devices to prevent UI freezing
export const MOBILE_TIMEOUT = 20000; // 20 seconds
export const DESKTOP_TIMEOUT = 30000; // 30 seconds
